import React, { useEffect, useState } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import AceHighwayResponseApiUrls from 'src/apiUrls/AceHighwayResponseApiUrls'
import AceHighwayKeys from 'src/constants/locale/key/AceHighwayResponse'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment-timezone'
import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import TablePagination from '../../../components/aciacehighway/TablePagination'
import clsx from 'clsx'
import ACEHighwayResponseTranslationText from 'src/views/acehighway/contexts/ACEHighwayResponseTranslationText'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL }
} = constants

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

function ShipmentResponse(props) {
  const { showNotification, scn, isViewOnly = false } = props

  const [data, setData] = useState([])
  const [lookups, setLookups] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { fetchRecords,fetchPageableRecords } = useServices()
  const { translate } = useTranslation([Namespace.ACE_HIGHWAY_RESPONSE])
  //const translatedTextsObject = makeTranslatedTextsObject()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const classes = useStyles()
  const [totalElements,setTotalElements] = useState(0)
  const [filter, setFilter] = useState([])
  const [sort, setSort] = useState({
    field: 'createdBy',
    direction:'ASC'
  })
  const aceHighwayResponseTranslationText = ACEHighwayResponseTranslationText()
  const naCommonTranslationText = NaCommonTranslationText()

  const fetchFilters = [
    {
      field: 'tripNo',
      operator: EQUAL,
      value: "SYSTEM"
    },
    {
      field: 'shipmentControlNo',
      operator: EQUAL,
      value: scn
    },
    {
      field: 'documentType',
      operator: EQUAL,
      value: 'ACE_SHIP'
    }
  ]
  

  useEffect(() => {
    fetchRecord(0,rowsPerPage)
    setPage(0)
  }, [])

  /*function makeTranslatedTextsObject() {
    let cbsaProcessingDate = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.CBSA_PROCESSING_DATE
    )
    let CBPRefNo = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.CBP_REF_NO
    )
    let tripNo = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.TRIP_NO
    )
    let responseCode = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.RESPONSE_CODE
    )
    let responseText = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.RESPONSE_TEXT
    )
    let batchId = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.BATCH_ID
    )
    let shipmentControlNo = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.SHIPMENT_CONTROL_NO
    )
    let entryNo = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.ENTRY_NO
    )
    let entryType = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.ENTRY_TYPE
    )
    let noOfPackage = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.NO_OF_PACKAGE
    )
    let responseDate = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.RESPONSE_DATE
    )
    let submissionType = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.SUBMISSION_TYPE
    )

    return {
      cbsaProcessingDate,
      CBPRefNo,
      tripNo,
      responseCode,
      responseText,
      batchId,
      shipmentControlNo,
      entryNo,
      entryType,
      noOfPackage,
      responseDate,
      submissionType
    }
  } */

  const columns = [
    {
      title: aceHighwayResponseTranslationText.cbsaProcessingDate,
      render: (data) =>
        data.cbsaProcessingDate &&
        moment(data.cbsaProcessingDate).tz("Canada/Eastern").format('D MMM YYYY - HH:mm')
    },
    { field: 'cbpRefNo', title: aceHighwayResponseTranslationText.CBPRefNo },
    { field: 'responseCode', title: aceHighwayResponseTranslationText.responseCode },
    { field: 'responseText', title: aceHighwayResponseTranslationText.responseText },
    { field: 'batchId', title: aceHighwayResponseTranslationText.batchId },
    // { field: 'noOfPkgs', title: translatedTextsObject.noOfPackage },
    // { field: 'entryNo', title: translatedTextsObject.entryNo },
    // { field: 'entryType', title: translatedTextsObject.entryType },
    // {
    //   title: `${translatedTextsObject.tripNo} & ${translatedTextsObject.shipmentControlNo}`,
    //   render: (data) => [data.tripNo, data.shipmentControlNo].join(', ')
    // },
    {
      title: aceHighwayResponseTranslationText.responseDate,
      render: (data) =>
        data.responseDate &&
        moment(data.responseDate).tz("Canada/Eastern").format('D MMM YYYY - HH:mm')
    }
    // ,
    // {
    //   title: translatedTextsObject.submissionType,
    //   render: (data) =>
    //     lookups
    //       ? lookups['submissionType'][data.submissionType]
    //       : data.submissionType
    // }
  ]

  function fetchRecord(newPage, newsRowsPerPage){
    fetchPageableRecords.execute(
      AceHighwayResponseApiUrls.GET,
      {
        page: newPage,
        pageSize: newsRowsPerPage,
        filters: [...fetchFilters, ...filter],
        sorts: [sort]
      },
      (result) => {
        setTotalElements(result.totalElements)
        setData(result.content)
      },
      (error) => console.log(error),
      () => {
      }
    )
  }
  const handleChangePage = (newPage) => {
    setPage(newPage)
    fetchRecord(newPage,rowsPerPage)
  }

  const handleChangeRowsPerPage = (rowsPerPage) => {
    setRowsPerPage(rowsPerPage)
    setPage(0)
    fetchRecord(0,rowsPerPage)
  }

  return (
    <>
      <TableContainer>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell key={index}>{column.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody key={data}>
            {data && totalElements > 0 ? (
              data
                .map((d) => (
                  <TableRow key={d.id}>
                    {columns.map((column, index) => (
                      <TableCell key={index}>
                        {column.render ? column.render(d) : d[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell
                  align='center'
                  colSpan={columns.length}
                >
                  <Typography variant='body2' color='textSecondary'>
                    {naCommonTranslationText.noRecordsMessage}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box padding={2}>
        <TablePagination
          count={data.length}
          itemsPerPage={rowsPerPage}
          onItemsPerPageChange={handleChangeRowsPerPage}
          onPageChange={handleChangePage}
          page={page}
        />
      </Box>
    </>
  )
}

export default ShipmentResponse
